import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.base_url = process.env.VUE_APP_API_BASE_URL
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')